import { useContext } from 'react';
export var createUseUpdate = function createUseUpdate(context) {
  return function () {
    var _useContext = useContext(context),
        update = _useContext.update;

    return update;
  };
};